export const monthsOfTheYear = "Enero, Febrero, Marzo, Abril, Mayo, Junio, Julio, Agosto, Septiembre, Octubre, Noviembre, Diciembre";

function addZero(numberToChange: number) {
    return (numberToChange < 10) ? '0' + numberToChange.toString() : numberToChange.toString();
}
export const getMonthAndYear = (date: string) => {
    let month = new Date(date).getMonth();
    month = month + 1;
    const selectedMonth = addZero(month);
    const selectedYear = new Date(date).getFullYear();
    return {month: selectedMonth, year: selectedYear.toString()};
}